import { makeAutoObservable, runInAction } from 'mobx';
import goxApi from 'api/gox-api';
import AlertStore from './Alert';
import Scooter from './Scooter';

class Scooters {

  selected = null;
  // zones = [];

  constructor() {
    makeAutoObservable(this);
  }

  async fetch(uuid) {
    return new Promise(async (resolve, reject) => {
      try {
        const { pricing_plans, scooter } = await goxApi.scooterShow(uuid);

        if (!scooter[0]) {
          return AlertStore.add('Scooter not found');
        }

        runInAction(() => {
          this.selected = new Scooter(scooter[0], pricing_plans);
        });

        resolve();
      } catch (err) {
        // AlertStore.add(err.message);
        reject(err);
      }
    });
  }

 async available(lat, lng) {
  // return new Promise(async (resolve, reject) => {
  //   try {
  //     const { zones } = await goxApi.scootersAvailable(lat, lng);
  //     runInAction(() => {
  //       this.zones = zones;
  //     });
  //   } catch (err) {
  //     reject(err);
  //   }
  // });
 }
   
}

const ScootersStore = new Scooters();
export default ScootersStore;
